import React from 'react';
import './Navbar.css';
function MenuItem(props)
{
    return(
        <a href={props.url}>
            {props.text}
        </a>
    );
}

class Navbar extends React.Component
{
    render()
    {
        return(
            <div className = "nav-bar">
                <div className = "nav-buttons">
                    <h1>std</h1>::string navBar&#91;&#93; = &#123; 
                    <MenuItem
                    text = '"home"'
                    url = '#home'
                    />
                    ,&#160;
                    <MenuItem
                    text = '"about"'
                    url = '#about'
                    />
                    ,&#160;
                    <MenuItem
                    text = '"portfolio"'
                    url = '#portfolio'
                    />
                    ,&#160;
                    <MenuItem
                    text = '"contact"'
                    url = '#contact'
                    />
                    &#125;;
                </div>
            </div>
        );
    }
}

export default Navbar